import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';

import { FDataGridToolbarAction } from './FDataGrid.models';

type Props = {
  title?: string;
  subtitle?: string;
  addRow?: () => void;
  saveAll?: () => void | Promise<void>;
  refresh?: () => void | Promise<void>;
  actions?: FDataGridToolbarAction[];
  sx?: any;
};

class FDataGridHeader extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
  }

  private renderIconAction = (
    label: string,
    icon: React.ReactNode,
    onClick?: () => void | Promise<void>,
  ) => {
    if (!onClick) return null;

    return (
      <Tooltip title={label}>
        <IconButton size="small" onClick={() => void onClick()}>
          {icon}
        </IconButton>
      </Tooltip>
    );
  };

  render() {
    const actions = (this.props.actions || []).filter((action) => !action.hidden);

    return (
      <Box
        sx={{
          px: 1.5,
          py: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          ...this.props.sx,
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          justifyContent="space-between"
        >
          <Box sx={{ minWidth: 0 }}>
            {this.props.title && (
              <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.25 }} noWrap>
                {this.props.title}
              </Typography>
            )}
            {this.props.subtitle && (
              <Typography variant="caption" color="text.secondary" noWrap>
                {this.props.subtitle}
              </Typography>
            )}
          </Box>

          <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="flex-end" flexWrap="wrap">
            {this.renderIconAction('Add row', <AddIcon fontSize="small" />, this.props.addRow)}
            {this.renderIconAction('Save all', <SaveIcon fontSize="small" />, this.props.saveAll)}
            {this.renderIconAction('Refresh', <RefreshIcon fontSize="small" />, this.props.refresh)}

            {actions.map((action) => (
              <Button
                key={action.key}
                size="small"
                variant={action.variant || 'text'}
                color={action.color || 'primary'}
                startIcon={action.icon}
                disabled={action.disabled}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            ))}
          </Stack>
        </Stack>
      </Box>
    );
  }
}

export default FDataGridHeader;
